import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';
// import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MailingPageRoutingModule } from './mailing-page-routing.module'
import { DataTablesModule } from 'angular-datatables';
import { MailingPageComponent } from './component/mailing-page/mailing-page.component';
import { HistoryMailingPageComponent } from './component/history-mailing-page/history-mailing-page.component'
import { BusAuctionFilterService } from '../home/services/bus-auction-filter.service';
import { HomeMainModalRegionComponent } from './component/home-main-modal-region/home-main-modal-region.component';
import { HomeMainModalDragComponent } from './component/home-main-modal-drag/home-main-modal-drag.component';
import { HomeMainModalCustomerComponent } from './component/home-main-modal-customer/home-main-modal-customer.component';
import { MessagePopupComponent } from '../modal-window/message-popup/message-popup.component';

@NgModule({
  providers: [BusAuctionFilterService
  ],
  imports: [
    MailingPageRoutingModule,
    CommonModule,
    DataTablesModule,
    FormsModule,
    TableModule,
    NgxSpinnerModule    
  ],
  declarations: [
    MailingPageComponent,
    HistoryMailingPageComponent,
    HomeMainModalRegionComponent,
    HomeMainModalCustomerComponent,
    HomeMainModalDragComponent,
    MessagePopupComponent]
})
export class MailingPageModule { }



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/mailing-page.module.ts